module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_catchform.55ef7754f5752f03c2f57961b75d2a59.png";